import { render, staticRenderFns } from "./WorkOutline.vue?vue&type=template&id=45364c8b&lang=pug&"
import script from "./WorkOutline.vue?vue&type=script&lang=js&"
export * from "./WorkOutline.vue?vue&type=script&lang=js&"
import style0 from "./WorkOutline.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports